import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollHSFEarningsSetup } from "../../components/PayrollHSFEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollWCBWSIBEarningsSetup } from "../../components/PayrollWCBWSIBEarningsSetup";

export const PayrollHSFEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll HSF Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll HSF Earnings", navigateTo: "/company/payrollHSFEarnings/setup" }
      ]}
      mainContents={<PayrollHSFEarningsSetup />}
    />
  );
};
